import { render, staticRenderFns } from "./add_news.vue?vue&type=template&id=c68937be&"
import script from "./add_news.vue?vue&type=script&lang=js&"
export * from "./add_news.vue?vue&type=script&lang=js&"
import style0 from "./add_news.vue?vue&type=style&index=0&id=c68937be&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports